const PianoGTM = (label: string) => {
  // Data layers GTM
  window.dataLayer.push({
    event: 'sz_conversion',
    sz_conversion_type: label,
  })
}

export default PianoGTM
